// Copyright (c) 2026 Aravind Adari. All rights reserved.

import { useState, useMemo, useCallback } from "react";

export default function usePagination<T>(items: T[], defaultRowsPerPage = 10) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(defaultRowsPerPage);

  const paginatedItems = useMemo(() => {
    const start = page * rowsPerPage;
    return items.slice(start, start + rowsPerPage);
  }, [items, page, rowsPerPage]);

  const onPageChange = useCallback((_: unknown, newPage: number) => {
    setPage(newPage);
  }, []);

  const onRowsPerPageChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      setRowsPerPage(parseInt(e.target.value, 10));
      setPage(0);
    },
    []
  );

  const resetPage = useCallback(() => setPage(0), []);

  return {
    page,
    rowsPerPage,
    paginatedItems,
    totalCount: items.length,
    onPageChange,
    onRowsPerPageChange,
    resetPage,
  };
}
